module.exports = __webpack_public_path__ + "static/media/1M8E7497-Edit_0.6dbd739f.jpg";